module.exports = __webpack_public_path__ + "media/dashboard/assets/images/WA_icon-956a433b3e791d1303556c8f981b9832.svg";